export const FEATURE = Object.freeze({
	TEST: "test-portal",
});
